import { IMModelingPrompt, IMSection } from '../../types'
import { parseLessons } from '../lesson'
import { createNodeList } from '../../../nodeCreationHelpers'
import { parseStandardsGroup } from '../standards'
import { filteredNoteNodes, parseLearningGoals } from '../utility'
import { parseQuestion } from '../question'
import { createNoteNode } from '../createNodeWrappers'
import { checkpointAssessment, checkpointNote } from './checkpoint'
import { sectionFamilySupportMaterials } from './familySupportMaterials'
import { ISimplifiedNode } from '../../../../components/ingestion/IngestedTree'
import { IM360Parser } from '../IM360Parser'

export function sectionChildren(
  section: IMSection,
  modelingPrompts: IMModelingPrompt[],
  {
    unitOrdinalTitle,
    unitFamilySupport,
  }: {
    unitOrdinalTitle: string
    unitFamilySupport?: string
  },
  assessments: Record<string, ISimplifiedNode[]>,
) {
  return [
    ...parseStandardsGroup(section.standards, section.ancillary_content),
    ...parseLearningGoals(section.ancillary_content),
    ...filteredNoteNodes(['Overview', section.narrative]),
    ...getExternalNotes(section),
    ...checkpointNote(section),
    ...sectionFamilySupportMaterials(unitOrdinalTitle, {
      sectionFamilySupport: section.family_support_materials,
      unitFamilySupport,
    }),
    createNodeList(
      { title: 'Lessons' },
      parseLessons(section.lessons, modelingPrompts),
    ),
    ...sectionPracticeProblems(section),
    ...checkpointAssessment(section),
    ...midUnitAssessments(section, assessments),
  ]
}

function midUnitAssessments(
  section: IMSection,
  assessmentsByLesson: Record<string, ISimplifiedNode[]>,
) {
  if (!Object.keys(assessmentsByLesson).length) return []
  const assessments = section.lessons.reduce<ISimplifiedNode[]>(
    (acc, { slug, title }) => {
      // check by slug and title, can't always get the slug, sometimes have title instead
      return [
        ...acc,
        ...(assessmentsByLesson[slug] ?? assessmentsByLesson[title] ?? []),
      ]
    },
    [],
  )
  if (!assessments.length) return []
  return [createNodeList({ title: 'Mid Unit Assessments' }, assessments)]
}

function getExternalNotes({ external_notes }: IMSection) {
  if (!external_notes) return []
  return external_notes.map(({ title, description }) => {
    return createNoteNode({ title, value: description, studentFacing: false })
  })
}

function sectionPracticeProblems({
  practice_problems,
  ordinal_title,
}: IMSection) {
  if (!practice_problems?.practice_problems?.length) return []
  return [
    createNodeList({ title: 'Practice Problems' }, [
      IM360Parser.getInstance().createAssessment(
        {
          title: `${ordinal_title} Practice Problems`,
          assignment: 'participation',
          assessment_grading: 'formative',
        },
        practice_problems?.practice_problems.flatMap(parseQuestion),
      ),
    ]),
  ]
}
